import Button from 'components/Button';

import image from './image.svg';

import styles from './styles.module.scss';

const BackButton = ({ className = '', disabled, onClick, id }) => (
    <div className={styles.backButton}>
        <img className={styles.image} alt="back arrow" src={image} />

        <Button
            className={`${styles.button} ${className}`}
            label="Back"
            onClick={onClick}
            id={id}
            disabled={disabled}
        />
    </div>
);

export default BackButton;
